/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClubDto } from '../models/ClubDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClubsService {

    /**
     * @returns ClubDto Success
     * @throws ApiError
     */
    public static getApiClubs(): CancelablePromise<Array<ClubDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clubs',
        });
    }

    /**
     * @param id 
     * @returns ClubDto Success
     * @throws ApiError
     */
    public static getApiClubs1(
id: number,
): CancelablePromise<ClubDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clubs/{id}',
            path: {
                'id': id,
            },
        });
    }

}
